import {BaseModel} from "./BaseModel";

export class StudentSalamatModel extends BaseModel {
    constructor(cookie = "") {
        super();
        this.cookie = cookie;

    }

    RouteName = "Salamat";
    AuthState = true;


    async Create(model) {
        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .post(`${this.RouteName}/Create`, model);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

    async Get() {

        try {
            return await this.baseApi
                .axiosInstance(true, this.cookie)
                .get(`${this.RouteName}/Get`);
        } catch (e) {
            const error = e;
            throw error.response?.data;
        }
    }

}
